<template>
  <v-container v-if="supplier.id > 0" class="home-on-table-view" id="HomeOnTableView">
    <v-tabs-items v-model="$store.state.shared.navTabPos" touchless>
      <v-tab-item>
        <topsort-home-header v-if="instance.ads_active"></topsort-home-header>
        <on-table-home-tab-main :flatSavedDataIndexedDb="flatSavedDataIndexedDb" :showCurrentCartBottom="showCurrentCartBottom" />
      </v-tab-item>
      <v-tab-item/>
      <v-tab-item v-if="instance.tab_button_search === true && !is_ontable_plazoleta">
        <home-tab-search />
      </v-tab-item>
      <v-tab-item v-if="instance.tab_button_contact === true && !is_ontable_plazoleta">
        <home-tab-contact />
      </v-tab-item>
    </v-tabs-items>
    <v-bottom-navigation v-model="$store.state.shared.navTabPos" class="menu-bottom" grow app>
      <v-btn active-class="home-bottom-top-border">
        <span class="font-weight-light" v-html="$t('main_menu.home_tab_title')"></span>
        <v-icon small>fa-light fa-house</v-icon>
      </v-btn>
      <v-btn @click="goMenu()">
        <span class="font-weight-light" v-html="getLabels('menu_tab_title')"></span>
        <v-icon small>fa-light fa-plate-utensils</v-icon>
      </v-btn>
      <v-btn v-if="instance.tab_button_search && !is_ontable_plazoleta" active-class="home-bottom-top-border">
        <span class="font-weight-light" v-html="$t('main_menu.order_tab_search')"></span>
        <v-icon small>fa-light fa-magnifying-glass</v-icon>
      </v-btn>
      <v-btn v-if="instance.tab_button_contact && supplier.on_table_class !== 'checkout' && !is_ontable_plazoleta" active-class="home-bottom-top-border">
        <span class="font-weight-light" v-html="$t('main_menu.order_tab_contact')"></span>
        <v-icon small>fa-light fa-bell</v-icon>
      </v-btn>
      <v-btn v-if="instance.tab_button_book" active-class="home-bottom-top-border" @click="goBook()">
        <span class="font-weight-light" v-html="$t('book')"></span>
        <v-icon small>fa-light fa-calendar-day</v-icon>
      </v-btn>
      <v-btn v-if="is_ontable_checkout || has_cluvipay" @click="goHistoryOrders()">
        <span class="font-weight-light" v-html="$t(`menu-digital.${is_ontable_checkout ? 'myorders' : 'mypayments'}`)"></span>
        <v-icon small>fa-light fa-square-list</v-icon>
      </v-btn>
    </v-bottom-navigation>
    <current-cart-bottom v-if="showCurrentCartBottom" @emptyList="showDialog" />
    <ot-dialog v-if="otdialog" :data="dialogData" @dismiss="hideDialog" @gotomenu="otdialog = false" />
    <ot-dialog v-if="displayWarningNotTableid" :data="warningNotTableidMessage" @dismiss="hideDialog" />
    <info-btns-overlay v-if="!template.loading && displayInfoOverlay"></info-btns-overlay>
    <rate-tab />
  </v-container>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import { misMixins } from "@/mixins/mixins.js";
import { track } from "@/services/track-custom";
import { OnTableCart } from '@/services/OnTableCart';
export let count = 0;

export default {
name: "OnTableHome",
beforeRouteLeave(to, from, next) {
  if (this.product_id && this.product_id.length > 0) {
    this.SetProductId(null);
    if (to.name === 'MyOrder' || to.name === 'DeliveryCartInProgress') next();
    else next(false);
  } else {
    next();
  };
},
components: {
  CurrentCartBottom: () => import (/* webpackChunkName: "currentCartBottom" */  '@/components/on_table/CurrentCartBottom.vue'),
  OnTableHomeTabMain: () => import(/* webpackChunkName: "OnTableHomeTabMain" */'@/components/share/HomeTabMain'),
  HomeTabContact: () => import(/* webpackChunkName: "HomeTabContact" */ "@/components/share/HomeTabContact"),
  HomeTabSearch: () => import(/* webpackChunkName: "HomeTabSearch" */ "@/components/share/HomeTabSearch"),
  OtDialog: () => import(/* webpackChunkName: "otDialog" */ '@/components/on_table/OtDialog.vue'),
  InfoBtnsOverlay: () => import(/* webpackChunkName: "infoBtnsOverlay" */  '@/components/on_table/InfoBtnsOverlay'),
  TopsortHomeHeader: () => import(/* webpackChunkName: "TopsortHomeHeader" */ '@/components/topsort/TopsortHomeHeader')
},
data() {
  return {
    categories: [],
    current_cat: undefined,
    panel_right: false,
    products: undefined,
    cat_products: undefined,
    show_menu_order: false,
    shoppingCart: {total: 0, purchase_product: [], products_in_cart: []},
    otdialog: false,
    dialogData: {
      title: '',
      message: '',
      btns: []
    },
    warningNotTableidMessage: {
      message: `No logramos identificar tu mesa. <br> Si deseas pedir y pagar debes <strong> escanear el QR
  </strong> en tu mesa. <br> De lo contrario puedes continuar explorando el menú visual.`,
      btns: []
    },
    onTableClassForServiceRoom: [
      'checkout_no_incremental',
      'checkout'
    ],
    timer: ""
  };
},
computed: {
  ...mapState('customer', ["instance", "supplier"]),
  ...mapState('template', ["template","isFirefox"]),
  ...mapState('order', ["service", "service_label", "otPurchaseId", "countProductsList"]),
  ...mapState('shared', ["mainCategoryId", "product_id","lang"]),
  ...mapState('profile', ["profile"]),
  ...mapState('ontable', ['displayInfoOverlay', 'displayWarningNotTableid','flatSavedDataIndexedDb']),
  ...mapGetters('customer', ["is_ontable_basic", 'is_ontable_plazoleta', 'is_ontable_checkout', "has_cluvipay", "is_colombian_customer", "getLabels", "is_mexican_customer"]),
  showCurrentCartBottom() {
    return (this.otPurchaseId !== null && !this.is_ontable_basic) || (this.is_ontable_basic && this.has_cluvipay)
  }
},
watch: {
  supplier (val) {
    if (val.id > 0 && !val.service_table) this.GoSelectSupplier();
    if (val.init_to_menu && !this.template.init_to_menu) {
      this.SetInitToMenu(true);
      this.goMenu();
    };
  }
},
created () {
  if(this.instance.cluvi_add_ons.includes('newhome')){
    this.$router.push({
        name: "OnTableNewHome",
        params: {supplier_id: this.supplier.slug}
      });
  }
  this.SetLoading(true);
  this.$store.state.shared.flatHomeMainCategories = null;
  this.reloadGetSupplier();
  this.initHomeOnTable();
},
mixins: [ misMixins ],
methods: {
  ...mapMutations('template', ["SetInitToMenu", "SetLoading", "TemplateActiveHeader", "SetAppClass"]),
  ...mapMutations('shared', ["setMainCategory", "SetProductId"]),
  ...mapMutations('ontable', ['setDisplayWarningNotTableid']),
  ...mapMutations('order', ['SetOtPurchaseId','setTip','setService']),
  calculate() {
    count++;
    return count;
  },
  GoSelectSupplier() {
    this.$router.push({ name: "Main" });
  },
  goOrder() {
    track.trackEventCluvi({}, "click to order footertabs");
    this.$router.push({
      name: "MyOrder",
      params: {supplier_id: this.supplier.slug}
    });
  },
  goMenu() {
    track.trackEventCluvi({}, "click to menu footertabs");
    let hasMainCategories = this.instance.has_main_categories;
    if (!hasMainCategories || this.mainCategoryId > 0) this.goToSubCategories();
    else this.goToMainCategories();
  },
  goBook() {
    track.trackEventCluvi({}, "click to book footertabs");
    if (this.supplier.service_book) {
      this.$router.push({
        name: "Book",
        params: {supplier_id: this.supplier.slug}
      });
    } else {
      this.$router.push({  name: "BranchToBook" });
    }
  },
  showDialog(data) {
    this.dialogData = { ...this.dialogData, ...data };
    this.otdialog = true;
  },
  goHistoryOrders() {
    this.$router.push({
      name: "HistoryMyOrders",
      params: {supplier_id: this.supplier.slug}
    });
  },
  hideDialog() {
    this.setDisplayWarningNotTableid(false);
    this.otdialog = false;
    this.SetOtPurchaseId(null)
  },
  setLabelMenu() {
  if (this.instance.country_code === "PE") this.labelBtnShowMenu = this.$t("show_menu_label[1]");
  else this.cartNoOrdersLabel = this.$t("cart_no_orders_label[0]");
  },
  setMessagesModalId () {
    if (this.supplier.service_room) this.warningNotTableidMessage.message = this.getLabels('warning_not_room_id_message');
    else this.warningNotTableidMessage.message = this.getLabels('warning_not_table_id_message');
  },
  setWarningNotTableidMessage() {
    this.$store.state.shared.productsFilter = "all";
    this.warningNotTableidMessage.btns.push({
      label: this.$i18n.t("menu-digital.continue_without_order"),
      color: 'cluvi2',
      id: 'yes',
      click: 'dismiss'
    });
  },
  flatInOnTableOtPurchase () {
    if (this.supplier.service_room && !this.onTableClassForServiceRoom?.includes(this.supplier.on_table_class)) this.SetOtPurchaseId(null);
  },
  initHomeOnTable () {
    let arrayCustomer = ['newo','parrilla-express','test-clemente'];
    let customInstance = arrayCustomer?.includes(this.instance.slug) && this.$route.query.mesa;
    let flatOnTableBasic = this.service === "on_table" && this.has_cluvipay && this.is_ontable_basic && (this.is_colombian_customer || this.is_mexican_customer);
    let solopago = this.$route.path.includes('/solo-pago');
    if (!this.service || this.service === 'book') this.setService('on_table');
    if (customInstance) {
      this.goToHomeOnTable();
    } else if (this.service !== "on_table") {
      this.goToHomeDelivery();
    } else if (flatOnTableBasic) {
      if (solopago) this.goToCart();
      else this.viewHomeOnTable();
    } else {
      this.viewHomeOnTable();
    };
  },
  viewHomeOnTable () {
    this.setDisplayWarningNotTableid(!!((this.is_colombian_customer || this.is_mexican_customer) && this.is_ontable_basic && this.supplier.on_table_class !== "basic"));
    this.$store.state.shared.navTabPos = 0;
    this.TemplateActiveHeader({ header_type: this.instance.back_option_home });
    this.SetAppClass("");
    this.calculate();
    this.flatInOnTableOtPurchase();
  },
  goToCart () {
    this.setTip({ include: 'YES', percent:10 });
    if (this.$route.name !== 'MyOrder') {
      if (this.is_ontable_basic && this.supplier.has_cluvi_pay && !this.otPurchaseId) this.getCreatePurchaseByManualPayment();
      else this.goToMyOrder();
    };
  },
  goToMyOrder() {
    this.$router.push({
      name: "MyOrder",
      params: { supplier_id: this.supplier.slug, purchase_id: this.otPurchaseId }
    });
  },
  goToMainCategories () {
    this.$router.push({
      name: "MainCategories",
      params: {supplier_id: this.supplier.slug}
    });
  },
  goToSubCategories () {
    this.$router.push({
      name: "SubCategories",
      params: { supplier_id: this.supplier.slug }
    });
  },
  goToHomeOnTable () {
    this.$router.push({
      name: "OnTableMenuDigital",
      params: { supplier_id: this.$route.params.supplier_id },
      query: { mesa: this.$route.query.mesa }
    });
  },
  goToHomeDelivery () {
    this.$router.push({
      name: "Home",
      params: { supplier_id: this.$route.params.supplier_id }
    });
  },
  async getCreatePurchaseByManualPayment () {
    try {
      const response = await OnTableCart.createPurchaseByManualPayment(0);
        if (response) {
          this.SetOtPurchaseId(response.data.id);
          this.goToMyOrder();
        };
    } catch (error) {
      console.error(error);
    };
  }
},
mounted() {
  track.trackView(this,`Home menu en mesa`,`/${this.supplier.slug}/menu-digital/home`);
  track.trackEventCluvi({}, "view home");
  this.setMainCategory(0);
  this.setWarningNotTableidMessage();
  this.setMessagesModalId();
  setTimeout(() => this.SetLoading(false), process.env.VUE_APP_DELAY);
},
metaInfo() {
  return {
    title: this.supplier.label
  };
}
};
</script>

<style lang="scss">
  .home-on-table-view {
    position: relative;
    height: 100%;
    justify-content: center;
    .v-btn.success {
      border-radius: 10px !important;
      text-transform: unset;
    }
    .bck_cta_primary {
      background-color: #7ed957 !important;
    }
    .home-bottom-top-border {
      border-top: 2px solid #ff2d55;
      border-radius: 0px !important;
    }
  }
</style>